<bb-dropdown-menu-ui buttonSize="sm" btnColor="secondary" optionLabelKey="language" icon="caret-down"
  [options]="localesCatalog" (select)="language = $event">
  <ng-template bbDropdownLabel>
    <i class="flag-icon"
      [ngClass]="{'flag-icon-do': language?.code === 'es-DO', 'flag-icon-us': language?.code === 'en-US'}"></i>
    <span *ngIf="language?.code === 'es-DO'" i18n="@@bn-set-locale-widget.option.spanish.span">Spanish</span>
    <span *ngIf="language?.code === 'en-US'" i18n="@@bn-set-locale-widget.option.english.span">English</span>
  </ng-template>
  <ng-template bbDropdownMenuItem>
    <div *ngIf="language?.code === 'es-DO'">
      <a href="javascript:void(0)" class="dropdown-item" (click)="setLocale('en-US')"
        i18n="@@bn-set-locale-widget.option.english.lbl"><i class="flag-icon flag-icon-us w-25"></i> English</a>
    </div>
    <div *ngIf="language?.code === 'en-US'">
      <a href="javascript:void(0)" class="dropdown-item" (click)="setLocale('es-DO')"
        i18n="@@bn-set-locale-widget.option.spanish.lbl"><i class="flag-icon flag-icon-do w-25"></i> Spanish</a>
    </div>
  </ng-template>
</bb-dropdown-menu-ui>